import React from 'react';
import { DateTimeText } from './DateTimeText';
import { isRowDeleted } from '../utils/status-transitions.utils';
import type { MunicipalListAccommodation } from '../types/pre-registration.types';

interface NotificationStatusProps {
  row: Pick<MunicipalListAccommodation, 'status' | 'notifiedAt'>;
}

// Whether the row was already sent to Fiscalización (deleted rows are never sent)
export const NotificationStatus: React.FC<NotificationStatusProps> = ({ row }) => {
  if (row.notifiedAt) {
    return (
      <span className="text-xs text-gray-600">
        Notificado el <DateTimeText value={row.notifiedAt} />
      </span>
    );
  }
  if (isRowDeleted(row)) return <span className="text-xs text-gray-400">—</span>;
  return <span className="text-xs font-medium text-amber-700">Pendiente de notificar</span>;
};
